import { render, staticRenderFns } from "./LandAndBuildingCards.vue?vue&type=template&id=7177a142&"
import script from "./LandAndBuildingCards.vue?vue&type=script&lang=js&"
export * from "./LandAndBuildingCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports